import { Link } from 'react-router-dom'

import { Progress } from '@/components'
import { cn } from '@/lib/utils'

import { Ordem } from '../../domain/ordem'

export default function Component({ ordem }: { ordem: Ordem }) {
  return (
    <Link to={`/app/entity/ordens/servico/${ordem.id}/detalhes`}>
      <div className="space-y-2 rounded-lg border bg-muted p-4 shadow-sm">
        {/* ORDER AND CLIENT INFO */}
        <div className="flex items-center gap-2 border-b border-b-zinc-300 pb-2">
          <div className="text-4xl">{String(ordem.id).padStart(5, '0')}</div>
          <div className="grid flex-1 grid-rows-2">
            <div className="overflow-hidden text-ellipsis text-nowrap">
              {ordem.clienteNome}
            </div>
            <div className="overflow-hidden text-ellipsis text-nowrap font-bold">
              {ordem.equipamentoNome}
            </div>
          </div>
        </div>

        {/* DATES */}
        <div>
          <div className="flex items-center justify-between">
            <div>{ordem.aprovadoEm ? 'Data aprovação' : 'Data abertura'}</div>
            <div>
              {!ordem.aprovadoEm
                ? ordem.abertaEm.toLocaleString()
                : ordem.aprovadoEm.toLocaleString()}
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div>{ordem.entregaEm ? 'Data entrega' : 'Orçamento até'}</div>
            <div>
              {!ordem.entregaEm
                ? ordem.dataMaxOrcamento.toLocaleString()
                : ordem.entregaEm.toLocaleString()}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-1">
          <Progress value={ordem.progresso.valor} className="h-2 flex-1" />
          <div
            className={cn(
              'font-bold',
              ordem.progresso.diasRestantes < 0 && 'text-red-500',
            )}
          >
            {ordem.progresso.diasRestantes}d
          </div>
        </div>

        {ordem.tipoBloqueio && ordem.observacao && (
          <div>
            <strong>Observações:</strong> {ordem.observacao}
          </div>
        )}
      </div>
    </Link>
  )
}
